export default __webpack_public_path__ + "static/media/heraldofxotlihead.99596edc.png";